/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, Feb 2023
 * @flow
 */

import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import classes from './TableLookup.module.css';
import strings from '../../../../globalization';
import Whiteboard from '../../../Playground/components/Body/Whiteboard';
import Button from '../../../../components/Button';

const TableLookup = ({ onClosePopup, shapes, showEmployeeList, seatWithoutTableSelection }) => {
  const [updatedShapes, setUpdatedShapes] = useState(new Map());
  const [shapesColor, setShapesColor] = useState(new Map());

  useEffect(() => {
    const allShapes = Array.isArray(shapes) ? shapes : [];
    let copiedShapes = new Map();
    let colors = new Map();
    allShapes.forEach(shape => {
      copiedShapes.set(shape.id, {
        ...shape,
        selected: false,
      });
      if (shape.stationId) {
        colors.set(shape.stationId, shape.stroke);
      }
      // if (shape.occupied || shape.isTableMerged) {
      //   copiedShapes.set(shape.id, {
      //     ...shape,
      //     stroke: 'grey',
      //   });
      // } else {
      //   copiedShapes.set(shape.id, {
      //     ...shape,
      //     stroke: 'white',
      //   });
      // }
    });
    setUpdatedShapes(copiedShapes);
    setShapesColor(colors);
  }, [shapes]);

  const onSelectShape = (shape) => {
    if (shape?.stationId) {
      if (shape.occupied) {
        toast.warning(strings.table + ` ${shape.stationNumber} ` + strings.anotherTableSelect, { autoClose: 1000 });
      } else if (shape.isTableMerged) {
        toast.warning(strings.table + ` ${shape.stationNumber} ` + strings.alreadyMerged, { autoClose: 1000 });
      } else {
        let copiedShapes = new Map(updatedShapes);
        copiedShapes.set(shape.id, {
          ...shape,
          selected: !shape.selected,
          stroke: shape.selected ? shapesColor.get(shape.stationId) : 'white',
        });
        setUpdatedShapes(copiedShapes);
      }
    }
  };

  const onSeatWithoutTableSelection = () => {
    seatWithoutTableSelection && seatWithoutTableSelection();
  };
  const seatSelectedTables = () => {
    const selectedTables = Array.from(updatedShapes.values()).filter(eachShape => eachShape?.selected);
    showEmployeeList && showEmployeeList(selectedTables);
  };

  const isAnyTableSelected = () => {
    return Array.from(updatedShapes.values()).filter(eachShape => eachShape?.selected).length > 0;
  };

  return (
    <div className={classes.container}>
      <div className={classes.headerWrapper}>
        <div className={classes.headerTxt}>{strings.selectTable}{`(s)`}</div>
        <div className={classes.closeBtn} onClick={onClosePopup}>X</div>
      </div>
      <div className={classes.bodyWrapper}>
        <Whiteboard
          shapes={updatedShapes}
          draggable={false}
          selectShape={onSelectShape}
          tableInfoColumn='stationNumber'
          height="88vh"
          backgroundColor={'#3a3a3a'}
          stageContainerBackgroundColor={'#3a3a3a'}
        />
      </div>
      <div className={classes.footerWrapper}>
        <Button className={classes.btn} onClick={onSeatWithoutTableSelection} disabled={isAnyTableSelected()}>
          <div className={classes.btnTxt}>{strings.seatWithoutSelection}</div>
        </Button>
        <Button className={classes.btn} onClick={seatSelectedTables} disabled={!isAnyTableSelected()}>
          <div className={classes.btnTxt}>{strings.seatSelectedTable.toUpperCase()}{`(S)`}</div>
        </Button>
      </div>
    </div>
  );
};

export default TableLookup;

TableLookup.propTypes = {
  onClosePopup: PropTypes.func,
  showEmployeeList: PropTypes.func,
  seatWithoutTableSelection: PropTypes.func,
  shapes: PropTypes.array,
};

TableLookup.defaultProps = {
  onClosePopup: () => { },
  showEmployeeList: () => { },
  seatWithoutTableSelection: () => { },
  shapes: [],
};
